import { error, finish } from '../../../../modules/ladders/actions/masterLadder/deletePrice';
import api from '../../../../api';

export function request(dispatch, { price }) {
    // api.del(`/ladders/masterladder/delete-price`, price).then(
    //     ladder => dispatch(finish(ladder)),
    //     ({errors}) => dispatch(error(errors))
    // );

    $appState.sdkStaff.trading.deletePriceStepFromPriceLadder({requestBody: price})
        .then(data => dispatch(finish(data)))
        .catch(errors => dispatch(error(errors)));
}
